// src/lib/getImageSrc.ts
export function getImageSrc(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (/^https?:\/\//i.test(path)) return path;
  const API = (process.env.NEXT_PUBLIC_API_URL || "").replace(/\/$/, "");
  const rel = path.startsWith("/") ? path : `/${path}`;
  return API ? `${API}${rel}` : rel;
}
